import { cn } from "@omni/utils/styles";

import { Spinner } from "@/components/General/Spinner/spinner.component";
import { Config } from "@/utils/config.utils";

export const SearchResultsSkeletonComponent = () => {
    return (
        <div
            id={"search__loading"}
            className={cn("tw:w-full tw:h-dvh", {
                "tw:min-h-0 tw:lg:min-h-0": Config.general.author
            })}
        >
            <div
                className={cn(
                    "tw:w-full tw:h-dvh tw:flex tw:items-center tw:flex-col tw:justify-center tw:z-200 tw:fixed tw:top-0 tw:left-0 tw:bg-white"
                )}
            >
                <Spinner />
            </div>
        </div>
    );
};
